var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_767_1329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9147 24.575C12.2561 24.575 12.2429 23.6639 12.1244 23.016C11.8543 21.5392 11.0078 20.2311 10.0269 18.9301L9.66374 18.4554L8.92081 17.5008L8.55054 17.0175L8.18743 16.5278C6.99429 14.8829 6 13.1029 6 10.8966C6 7.15225 8.98746 4.10487 12.7115 4.00265L12.9048 4L13.098 4.00265C16.8221 4.10487 19.8095 7.15225 19.8095 10.8966C19.8095 13.1029 18.8152 14.8829 17.6221 16.5278L17.259 17.0175L16.8887 17.5008L16.1458 18.4554L15.7827 18.9301C14.8185 20.2089 13.8631 21.2925 13.6407 23.0237C13.5577 23.6695 13.5658 24.575 12.9147 24.575Z",
    fill: "#00B2E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.48421 17.8353L8.48419 17.8353L8.48678 17.8386L9.2283 18.7914L9.58769 19.2612C9.58806 19.2617 9.58843 19.2622 9.5888 19.2627C10.5638 20.5559 11.3383 21.7751 11.5834 23.115C11.6006 23.2092 11.6139 23.2991 11.6287 23.3997C11.6386 23.4668 11.6492 23.5387 11.6621 23.6197C11.6913 23.8022 11.7299 24.0117 11.794 24.2086C11.8569 24.4018 11.9584 24.629 12.1415 24.8118C12.3414 25.0113 12.6059 25.125 12.9147 25.125C13.2227 25.125 13.4879 25.0106 13.686 24.8063C13.8667 24.6199 13.962 24.3897 14.0187 24.1958C14.0996 23.9187 14.1357 23.5686 14.1628 23.3059C14.1711 23.2255 14.1786 23.1532 14.1862 23.0938C14.366 21.6944 15.0641 20.7797 15.9278 19.6481C16.0235 19.5226 16.1214 19.3945 16.2207 19.2627C16.2211 19.2622 16.2215 19.2617 16.2218 19.2612L16.5812 18.7914L17.3227 17.8386L17.3228 17.8386L17.3253 17.8353L17.6956 17.3519L17.6956 17.352L17.7008 17.3451L18.0639 16.8554L18.0639 16.8554L18.0673 16.8507C19.2812 15.1772 20.3595 13.2795 20.3595 10.8966C20.3595 6.85295 17.1335 3.56322 13.1131 3.45286L13.1131 3.4528L13.1056 3.4527L12.9123 3.45005H12.8972L12.704 3.4527L12.704 3.45265L12.6964 3.45286C8.67602 3.56322 5.45 6.85295 5.45 10.8966C5.45 13.2795 6.5283 15.1772 7.74222 16.8507L7.7422 16.8507L7.74563 16.8554L8.10875 17.3451L8.10869 17.3451L8.11393 17.3519L8.48421 17.8353Z",
    stroke: "#00B2E3",
    strokeWidth: 1.1,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_767_1329",
    x: 0.900391,
    y: 0.899902,
    width: 24.0088,
    height: 30.7749,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_767_1329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_767_1329",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map_pin.6003d3470e96bd2cf92d720e91dc285f.svg";
export { ForwardRef as ReactComponent };